import { render, staticRenderFns } from "./DettagliProponente.vue?vue&type=template&id=3bc8b62e&scoped=true&"
import script from "./DettagliProponente.vue?vue&type=script&lang=js&"
export * from "./DettagliProponente.vue?vue&type=script&lang=js&"
import style0 from "./DettagliProponente.vue?vue&type=style&index=0&id=3bc8b62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8b62e",
  null
  
)

export default component.exports